/*

Ashraf 11/03/2022 3075276647 added state management for communication opt outs.
Sai Maheshwar 11/03/2022 3075276647 added Communication opt-outs save API reducer
   Sai Maheshwar 11/05/2022 3075276647 Added optout API

*/

import { createSlice } from '@reduxjs/toolkit';
import { httpGet, httpPost } from '../../util/Rest';
import { DEBTOR } from '../../constants/MicroServiceConstants';
import { MARITAL_STATUS, STATE, PHONE_TYPE, APPROVAL, RP_PHONE_TYPE } from '../../constants/Lookup';
import { deleteWorkQueueByAccountNumber } from './WorkQueue';
import {
  clearWindowError,
  deleteModifiedWindowSessionItem,
  removeModifiedWindow,
} from './ModifiedWindows';
import { COMMUNICATION_OPT_OUTS, PATIENT_CUSTOMER_INFORMATION } from '../../util/Content';

const initialData = {
  customerDemographicsData: {},
  optOutsData: {},
  dropDownData: {},
  customerDemographicsStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'customerDemographics',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCustomerDemographicsData: (state, action) => {
      state.customerDemographicsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchCommunicationOptOuts: (state, action) => {
      state.optOutsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postCommunicationOptOutsData: (state, action) => {
      state.customerDemographicsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postCustomerDemographicsData: (state, action) => {
      state.customerDemographicsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetCustomerDemographicsStatus: (state) => {
      state.customerDemographicsStatus = null;
      state.customerDemographicsData = {};
      state.isLoading = false;
    },
    resetCustomerDemographicsData: (state) => {
      state.customerDemographicsData = {};
      state.optOutsData = {};
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchCustomerDemographicsData,
  fetchDropDownData,
  postCustomerDemographicsData,
  fetchCommunicationOptOuts,
  fetchStart,
  fetchError,
  resetMsg,
  fetchSuccess,
  resetCustomerDemographicsStatus,
  resetCustomerDemographicsData,
  postCommunicationOptOutsData,
} = slice.actions;

export const fetchCustomerDemographics = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [MARITAL_STATUS, STATE, PHONE_TYPE, APPROVAL, RP_PHONE_TYPE],
      }),
      httpGet(`${DEBTOR}/find/generalinfo/${accountNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const demographicsData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (demographicsData && demographicsData.status && demographicsData.status === 200) {
          dispatch(fetchCustomerDemographicsData(demographicsData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postCustomerDemographics = ({ isDirty, ...details }) => {
  return (dispatch) => {
    console.log('REACHED HERE');
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/generalinfo`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({ accountNumber: details?.accountNumber, isDirty }),
          );
          dispatch(postCustomerDemographicsData(data));
          dispatch(fetchSuccess(data));
          deleteModifiedWindowSessionItem(PATIENT_CUSTOMER_INFORMATION);
          dispatch(removeModifiedWindow({ windowName: PATIENT_CUSTOMER_INFORMATION }));
          dispatch(clearWindowError({ windowName: PATIENT_CUSTOMER_INFORMATION }));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : error));
      });
  };
};

export const postCommunicationOptOuts = (details, isDirty) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`debtor/save/optout `, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({ accountNumber: details?.accountNumber, isDirty }),
          );
          dispatch(postCommunicationOptOutsData(data));
          dispatch(fetchSuccess(data));
          deleteModifiedWindowSessionItem(COMMUNICATION_OPT_OUTS);
          dispatch(removeModifiedWindow({ windowName: COMMUNICATION_OPT_OUTS }));
          dispatch(clearWindowError({ windowName: COMMUNICATION_OPT_OUTS }));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : error));
      });
  };
};

export const fetchCommunicationOptOutsData = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`debtor/find/optout/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchCommunicationOptOuts(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetCustomerDemographics = () => {
  return (dispatch) => {
    dispatch(resetCustomerDemographicsStatus());
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetData = () => {
  return (dispatch) => {
    dispatch(resetCustomerDemographicsData());
  };
};
